import { laptopMaxXL, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';

export const AgentBox = styled.div<{ color?: string }>`
  background: ${(props) => props.theme.background};
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  overflow: hidden;
  max-width: 800px;

  ${(props) =>
    props.color &&
    `
    border: 2px solid ${props.color};
  `}
`;

export const AgentBoxInner = styled.div`
  & > div {
    margin: 10px 30px;
  }

  @media (${laptopMaxXL}) {
    display: flex;

    & > div {
      flex: 1;
    }
  }

  @media (${tabletMax}) {
    flex-direction: column;

    & > div {
      margin: 10px 15px;
    }
  }
`;

export const AgentButtons = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
`;

export const AgentBoxHeader = styled.div<{ color?: string }>`
  width: 100%;
  background-color: ${(props) => (props.color ? props.color : 'transparent')};
  padding: ${(props) => (props.color ? '10px' : '20px 20px 0')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Divider = styled.div`
  width: calc(100% - 30px);
  margin: 30px 15px;
  background-color: ${({ theme }) => theme.keyline};
  height: 1px;
`;

export const AgentExtraInfo = styled.div`
  flex: 1;
  padding-top: 20px;
  border-top: 1px solid ${({ theme }) => theme.keyline};

  @media (${laptopMaxXL}) {
    border-top: none;
    border-left: 1px solid ${({ theme }) => theme.keyline};
    padding-left: 20px;
  }

  @media (${tabletMax}) {
    border-top: 1px solid ${({ theme }) => theme.keyline};
    border-left: none;
    padding-left: 0;
  }
`;

export const AgentListItem = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

export const IconBox = styled.div`
  min-width: 18px;
  margin: 2px 10px 0 0;
  display: flex;
  justify-content: center;
`;

export const AgentLogo = styled.img`
  display: block;
  max-width: 250px;
  max-height: 60px;
`;

export const AgentText = styled.p`
  color: ${(props) => props.theme.textMid};
  font-size: 14px;
  text-align: center;
  margin-bottom: 15px;
`;

export const LicenceWarning = styled(Link)`
  width: 20px;
  height: 20px;
  background-color: ${(props) => props.theme.primary};
  border-radius: 10px;
  display: inline-block;
  font-weight: bold;
  color: ${(props) => props.theme.white};
  margin-left: 5px;
`;

export const BrokerBox = styled.div`
  margin: 0 30px 30px;
  border-top: 1px solid ${(props) => props.theme.keyline};
  display: flex;
  align-items: center;
  flex-direction: column;

  img {
    max-width: 160px;
    max-height: 100px;
    margin: 15px 0;
  }

  @media (${tabletMax}) {
    margin: 0 15px 15px;
  }
`;
